<template>
  <div class="userinfo-container">
    <el-form :inline="true" :model="filters">
      <el-form-item style="margin-bottom: 0px" label="关键字">
        <el-input
          size="small"
          v-model="filters.search"
          placeholder="关键词"
          clearable
          style="width: 200px"
          @keyup.native.enter="queryAll"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px" label="排序">
        <el-radio-group v-model="filters.orderby" size="small">
          <el-radio-button
            v-for="item in orders"
            :value="item.value"
            :key="item.value"
            :label="item.value"
            >{{ item.name }}</el-radio-button
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item style="margin-bottom: 0px">
        <el-button size="small" type="primary" @click="queryAll"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <div class="tabs-container">
      <el-tabs v-model="filters.status" @tab-click="typeChange">
        <el-tab-pane label="全部" name="all" key="all"></el-tab-pane>
        <el-tab-pane
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.key"
          :label="tab.name"
        >
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-table border :data="datas" style="width: 100%" size="small">
      <el-table-column type="expand">
        <template slot-scope="scope">
          <div v-if="scope.row.Attachments">
            <attachmentList :attachments="scope.row.Attachments.Items" />
          </div>
          <div v-if="scope.row.Desc">
            <el-card>
              {{ scope.row.Desc }}
            </el-card>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="Name"
        label="标题"
        min-width="120"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="Category.Name" label="分类" width="180">
        <template slot-scope="scope">
          <categorySelector 
            :options="options"
            style="width: 150px"
            @change="doSave(scope.row)"
            v-model="scope.row.Category"
          />
        </template>
      </el-table-column>
      <el-table-column label="状态" width="200">
        <template slot-scope="scope">
          <el-radio-group 
            v-model="scope.row.Status"
            @change="doSave(scope.row)"
            size="small"
          >
            <el-radio-button
              v-for="item in $config.tenantStatus"
              :value="item.value"
              :key="item.value"
              :label="item.value"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
        </template>
      </el-table-column>
      <el-table-column prop="Member.Mobile" label="发布人手机号" width="200"></el-table-column>
      <el-table-column prop="Member" label="发布人" width="200">
        <template slot-scope="scope">
          <div>
            <img
              v-if="scope.row.Member.HeadImage"
              :src="
                scope.row.Member.HeadImage.indexOf('http') == 0
                  ? scope.row.Member.HeadImage
                  : baseUrl + scope.row.Member.HeadImage
              "
              :key="scope.row.Member.HeadImage"
              width="30"
            />
            <span>{{ scope.row.Member.RealName }}</span
              >
              <span v-if="scope.row.Member.Actor.Code!='HT'">@{{ scope.row.Member.Actor.Name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="InsertTime" sortable label="发布时间" width="130">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="AdHomeOrder" label="主页推荐位次" width="160">
        <template slot-scope="scope">
          <el-input-number
            size="small"
            v-model="scope.row.AdHomeOrder"
            @change="doSave(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column prop="AdChannelOrder" label="频道推荐位次" width="160">
        <template slot-scope="scope">
          <el-input-number
            size="small"
            v-model="scope.row.AdChannelOrder"
            @change="doSave(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleRemove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="pageSizesList"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
        :current-page.sync="pageIndex"
      ></el-pagination>
    </div>
  </div>
</template>
    <script>
import { getPageList, save, del } from "@/api/business/publish.js";
import attachmentList from "@/components/attachmentList.vue";
import categorySelector from "@/components/categorySelector.vue";
import { getAll } from "@/api/business/category";
export default {
  components: {categorySelector, attachmentList },
  data() {
    return {
      tabs:[],
      options:[],
      orders: [
        { key: 0, name: "发布时间", value: 0 },
        { key: 1, name: "推荐位次", value: 1 },
        { key: 2, name: "频道位次", value: 2 },
      ],
      datas: [],
      filters: {
        search: "",
        tenant: "",
        status:'all',
        orderby: 0,
      },
      pageIndex: 1,
      pageSize: 10,
      pageSizesList: [10, 15, 20, 30, 50],
      totalCount: 0,
    };
  },
  methods: {
    typeChange() {
      this.queryAll();
    },
    queryAll() {
      let param = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        search: this.filters.search,
        orderby: this.filters.orderby,
        status:this.filters.status,
        tenant: this.filters.tenant ? this.filters.tenant.Key : "",
      };
      getPageList(param).then((res) => {
        this.datas = res.Items;
        this.totalCount = res.Total | res.Items.length;
      });
    },
    doSave(row) {
      console.log(row);
      save(row).then((res) => {
        if (res) {
          this.msg.successMsg("保存成功！");
        }
      });
    },
    handleRemove(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let param = {
          key: row.Key,
        };
        del(param)
          .then((res) => {
            if (res) {
              this.queryAll();
            }
          })
          .catch((ex) => {});
      });
    },
    handleSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.queryAll());
    },
    handleCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.queryAll();
    },
    getAllCategorys() {
      let param = {type:4};
      getAll(param).then((res) => {
        if (res) {
          this.options = res;
        }
      });
    },
  },
  mounted() {
    this.tabs = this.$config.tenantStatus;
    this.queryAll();
    this.getAllCategorys();
  },
};
</script>
    <style lang='scss' scoped>
.userinfo-container {
  padding: 10px;
}
/deep/.el-dialog {
  margin-top: 10px !important;
}
</style>